<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="105px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="服务网点" prop="nursinghomeId">
              <el-select
                disabled v-model="form.nursinghomeId"
                style="width: 100%"
                placeholder="服务网点"
                @change="nursinghomeIdChange"
              >
                <el-option
                  v-for="item in nursinghomeIdList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="用户姓名" prop="userId">
              
              
              <el-select
                 :disabled="model==='view'" v-model="form.userId"
                style="width: 100%"
                placeholder="用户姓名"
                @change="userIdChange"
              >
                <el-option
                  v-for="item in userList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="身份证号" prop="idNumber">
              <el-input
              readonly
                clearable
                 :disabled="model==='view'" v-model="form.idNumber"
                placeholder="身份证号"
                maxlength="100"
              ></el-input>  
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系方式" prop="tel">
              <el-input
              readonly
                clearable
                 :disabled="model==='view'" v-model="form.tel"
                placeholder="联系方式"
                maxlength="100"
              ></el-input> 
            </el-form-item>
          </el-col>
          <!-- <el-col :span="8">
            <el-form-item label="使用机构" prop="consumableId"> </el-form-item>
          </el-col> -->
          <!-- <el-col :span="8">
            <el-form-item label="负责人" prop="principaler">
              <el-input
                clearable
                 :disabled="model==='view'" v-model="form.principaler"
                placeholder="负责人"
                maxlength="100"
              ></el-input> 
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="负责人联系电话" prop="principalTel"> 
              <el-input
                clearable
                 :disabled="model==='view'" v-model="form.principalTel"
                placeholder="负责人联系电话"
                maxlength="100"
              ></el-input> 
            </el-form-item>
          </el-col> -->
          <el-col :span="8">
            <el-form-item label="设备大类" prop="deviceCategory"> 
              
              <el-select
                 :disabled="model==='view'" v-model="form.deviceCategory"
                style="width: 100%"
                placeholder="设备大类"
                @change="nursinghomeIdChange"
              >
                <el-option
                  v-for="item in deviceCategoryList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="设备类型" prop="deviceTypeId"> 


              <el-select
                 :disabled="model==='view'" v-model="form.deviceTypeId"
                style="width: 100%"
                placeholder="设备类型"
                @change="nursinghomeIdChange"
              >
                <el-option
                  v-for="item in deviceTypeIdList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="设备型号" prop="deviceModelId"> 


              <el-select
                 :disabled="model==='view'" v-model="form.deviceModelId"
                style="width: 100%"
                placeholder="设备类型"
                @change="nursinghomeIdChange"
              >
                <el-option
                  v-for="item in deviceModelIdList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>

            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="设备标识ID" prop="deviceIdentificationId"> 
              
              <el-input
                clearable
                 :disabled="model==='view'" v-model="form.deviceIdentificationId"
                placeholder="设备标识ID"
                maxlength="100"
              ></el-input> 
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="SIM卡号" prop="simCard"> 
              
              <el-input
                clearable
                 :disabled="model==='view'" v-model="form.simCard"
                placeholder="SIM卡号"
                maxlength="100"
              ></el-input> 
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="设备序列号" prop="deviceSerial"> 
              
              <el-input
                clearable
                 :disabled="model==='view'" v-model="form.deviceSerial"
                placeholder="设备序列号"
                maxlength="100"
              ></el-input> 
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发放方式" prop="releaseMode">
              <el-select  :disabled="model==='view'" v-model="form.releaseMode" style="width: 100%" placeholder="请选择">
                <el-option
                  v-for="item in provideList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="销售价格" prop="sellingPrice">
              <money-input
                 :disabled="model==='view'" v-model="form.sellingPrice"
                templateName="元"
                template="append"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="服务费用" prop="serviceFee">
              <money-input
                 :disabled="model==='view'" v-model="form.serviceFee"
                templateName="元"
                template="append"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="支付方式" prop="paymentType"> 
              
              
              <el-select  :disabled="model==='view'" v-model="form.paymentType" style="width: 100%" placeholder="请选择">
                <el-option
                  v-for="item in paymentTypeList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="text-align: right" v-if="model != 'view'">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
        {{ model == 'add' ? '提交' : '修改' }}
      </el-button>
      <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small"> 取消 </el-button>
    </div>
  </div>
</template>
  <script>
import { getProjectList } from '@/api/crmedical/project/project';
import { getDictionary } from '@/api/common.js';
import {
  getMatetial,
  getNursinghome,
  getTotalWarehouseWarnSetting,
  stockWarnSave,
  getWarehouseWarnSetting,
  getNursingList,
  getDeviceTypeList,
  getDeviceModelList,
  saveWristband,
  getBasicInforDetail,
  updateWristband
} from '../api/serveItemManage';
export default {
  components: {},
  props: {
    row: {
      default: {},
    },
    nursinghomeId: {},
    model: {
      default: 'add',
    },
  },
  data() {
    return {
      projectList: [],
      provideList: [
      ],
      form: {
        nursinghomeId: '',
        downWarnValue: '',
        upWarnValue: '',
        releaseMode:""
      },
      formRules: {
        consumableName: [{ required: true, message: '物料名称不能为空', trigger: 'change' }],
        nursinghomeId: [{ required: false, message: '项目名称不能为空', trigger: 'change' }],
        consumableCode: [{ required: true, message: '物料编码不能为空', trigger: 'change' }],
      },
      matetialList: [],
      deviceCategoryList: [],
      userList: [],
      deviceTypeIdList: [],
      deviceModelIdList: [],
      nursinghomeIdList: [],
      paymentTypeList: [],
    };
  },
  created() {
    this.initData();
  },
  mounted() {},
  watch: {},
  methods: {
    userIdChange(val){
      let self = this;
      this.userList.forEach(ele=>{
        if(ele.id === val){
          self.form.tel = ele.tel;
          self.form.idNumber = ele.idNumber;
        }
      })
    },
    consumableIdChange() {
      this.form.warehouseList = [];

      if (this.form.consumableId != '') {
        getWarehouseWarnSetting({
          nursinghomeId: this.form.nursinghomeId,
          type: '0',
          consumableId: this.form.consumableId,
        }).then((res) => {
          this.form = res.data;

          this.form.type = 0;
        });
      }
    },
    async initData() {
      
          console.log('getBasicInforDetail======================>');
      if(this.model === 'add'){
      }else{
        this.form = this._.cloneDeep(this.row);;
      }
      getNursinghome().then((res) => {
        this.nursinghomeIdList = res.data;
      });
      getNursingList({id:this.nursinghomeId}).then(res=>{
        this.userList = res.data;
      })
      getDictionary('nursinghome_device_category').then((res) => {
        this.deviceCategoryList = res.data;
      });
      getDictionary('nursinghome_payment_type').then((res) => {
        this.paymentTypeList = res.data;
      });
      
      getDictionary('nursinghome_release_mode_type').then((res) => {
        this.provideList = res.data;
      });
          getDeviceTypeList({id: this.nursinghomeId}).then((res)=>{
            this.deviceTypeIdList = res.data;
          });
          getDeviceModelList({id: this.nursinghomeId}).then(res=>{
            this.deviceModelIdList = res.data;
          });
      if (this.model === 'add') {
        this.form.nursinghomeId = this.nursinghomeId;
        await getMatetial({ nursinghomeId: this.form.nursinghomeId }).then((res) => {
          this.matetialList = res.data;

          if (this.matetialList.length > 0) {
            this.form.consumableId = this.matetialList[0].id;
          }
        });
        //通过物料id获取仓库数据
        if (this.form.consumableId != '') {
          this.consumableIdChange();
        }
      } else {
      }
    },
    saveRecord() {
      if ((this.model === 'add')) {
        this.$refs['formRef'].validate((valid) => {
          if (valid) {
            saveWristband(this.form).then((res) => {
              this.$message.success('配置成功');
              this.$emit('success');
            });
          }
        });
      }else{
        
        this.$refs['formRef'].validate((valid) => {
          if (valid) {
            updateWristband(this.form).then((res) => {
              this.$message.success('配置成功');
              this.$emit('success');
            });
          }
        });
      }
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
  <style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
</style>
  